export const eventSponsorsStyle = {
	wrapper: {
		width: '100%',
	},

	title: {
		textAlign: 'center',
		marginBottom: '4px',
	},

	button: {
		padding: '10px 16px',

		'@media (max-width: 639.98px)': {
			width: '100%',
		},
	},

	afterTitle: {
		textAlign: 'center',
		marginBottom: '12px',

		'@media (max-width: 639.98px)': {
			marginBottom: '16px',
		},
	},
};
